export default __webpack_public_path__ + "static/media/onme_logo_ico.7c11a9a1.svg";